import React from 'react';

import Head from 'next/head';
import NewEventFinancials from 'screens/events/EventDashboard/new/NewEventFinancials';

const EventFinancialsScreen = () => (
  <>
    <Head>
      <title>Event Financials | Bounce</title>
    </Head>
    <NewEventFinancials />
  </>
);

export default EventFinancialsScreen;
